import classNames from 'classnames';
import React from 'react';
import { Block } from '../block/block.react-component';
import { Skeleton } from '../skeleton/skeleton.react-component';
import styles from "./block-skeleton.module.css";

/**
 * ### BlockSkeleton
 *
 * A generic {@link Block} component with a {@link Skeleton} wrapper.  Can be resized to any width and height via className.
 */
export const BlockSkeleton = _ref => {
  let {
    className,
    parentSkeletonProps = {}
  } = _ref;
  return /*#__PURE__*/React.createElement(Skeleton, parentSkeletonProps, /*#__PURE__*/React.createElement(Block, {
    className: classNames(styles['block-skeleton'], className)
  }));
};
//# sourceMappingURL=block-skeleton.react-component.js.map